import { create } from 'zustand';
import type { Order } from '@/types/domain';

interface OrdersState {
  byId: Record<number, Order>;
  upsert: (order: Order) => void;
  bulkUpsert: (orders: Order[]) => void;
  remove: (id: number) => void;
}

export const useOrdersStore = create<OrdersState>((set) => ({
  byId: {},
  upsert: (order) => set((s) => ({ byId: { ...s.byId, [order.id]: order } })),
  bulkUpsert: (orders) =>
    set((s) => {
      const next = { ...s.byId };
      for (const o of orders) next[o.id] = o;
      return { byId: next };
    }),
  remove: (id) =>
    set((s) => {
      const next = { ...s.byId };
      delete next[id];
      return { byId: next };
    }),
}));
